"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _reactMedia = _interopRequireDefault(require("react-media"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Breakpoints = require("./Breakpoints");

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var ShutterflyMedia = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ShutterflyMedia, _React$Component);

  var _super = _createSuper2(ShutterflyMedia);

  function ShutterflyMedia() {
    (0, _classCallCheck2.default)(this, ShutterflyMedia);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ShutterflyMedia, [{
    key: "render",
    value: function render() {
      var queryString = (0, _Breakpoints.toMediaQuery)({
        min: this.props.min,
        max: this.props.max
      }); // Use createElement here, in order to properly pass-through the 'children' prop.

      return _react.default.createElement(_reactMedia.default, (0, _assign.default)({}, this.props, {
        query: queryString
      }));
    }
  }]);
  return ShutterflyMedia;
}(_react.default.Component);

exports.default = ShutterflyMedia;
ShutterflyMedia.propTypes = {
  min: _propTypes.default.string,
  max: _propTypes.default.string
};
ShutterflyMedia.defaultProps = {
  min: null,
  max: null
};